export default "__VITE_ASSET__ZJY0kwCd__"